export const OVERLAY_VISIBLE_DURATION = 3000;
export const MUSIC_DEPARTMENT_CODE = 100;
export const SOFTWARE_DEPARTMENT_CODES = [100, 110, 92];

export const ADD_TO_CART_LABEL = 'Add to cart';
export const VIEW_LABEL = 'View';
export const NOTIFY_ME_LABEL = 'Notify me';
export const PRE_ORDER_LABEL = 'Pre-order';
export const CHECK_AVAILABILITY_LABEL = 'Check availability';
